export default function AIChecklistIcon({ width = 26, height = 26, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M15 23H25' stroke='url(#paint0_linear_1363_148)' strokeWidth='2' strokeLinecap='round' />
      <path d='M15 3H25' stroke='url(#paint1_linear_1363_148)' strokeWidth='2' strokeLinecap='round' />
      <path d='M15 9.66797H25' stroke='url(#paint2_linear_1363_148)' strokeWidth='2' strokeLinecap='round' />
      <path d='M15 16.332H25' stroke='url(#paint3_linear_1363_148)' strokeWidth='2' strokeLinecap='round' />
      <path
        d='M11 1L4.33334 9L1 6.6'
        stroke='url(#paint4_linear_1363_148)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.50002 16.5L1 25'
        stroke='url(#paint5_linear_1363_148)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1 16.5078L9.50002 24.9879'
        stroke='url(#paint6_linear_1363_148)'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient id='paint0_linear_1363_148' x1='15' y1='23.5' x2='25' y2='23.5' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient id='paint1_linear_1363_148' x1='15' y1='3.5' x2='25' y2='3.5' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_1363_148'
          x1='15'
          y1='10.168'
          x2='25'
          y2='10.168'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_1363_148'
          x1='15'
          y1='16.832'
          x2='25'
          y2='16.832'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient id='paint4_linear_1363_148' x1='1' y1='5' x2='11' y2='5' gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_1363_148'
          x1='1'
          y1='20.75'
          x2='9.50002'
          y2='20.75'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
        <linearGradient
          id='paint6_linear_1363_148'
          x1='1'
          y1='20.7478'
          x2='9.50002'
          y2='20.7478'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#9073CA' />
          <stop offset='0.485753' stopColor='#785BD4' />
          <stop offset='1' stopColor='#593EE4' />
        </linearGradient>
      </defs>
    </svg>
  );
}
